import CancerPage from "../components/CancerPage";

const stepsText = [
  "Endoscopy with Biopsy: This is the most crucial step. An endoscope is passed through the mouth to visualize the esophagus and obtain tissue samples for pathological examination.",
  "Endoscopic Ultrasound (EUS): Often performed during the endoscopy, uses an ultrasound probe to assess the depth of tumor invasion and nearby lymph nodes.",
  "PET (Positron Emission Tomography) scan: Helps determine if the lesion is metabolically active and identifies potential spread to other parts of the body.",
  "Additional CT scans: A full series of CT images of the chest, abdomen, and pelvis to assess the extent of the disease.",
  "Blood tests: To check for general health, assess organ function, and look for any tumor markers.",
];

export default function EsophagusCancerPage() {
  return (
    <CancerPage
      cancerName="Esophagus Cancer"
      scanType="CT / MRI Scan"
      analysisText="Based on the provided chest CT scan, a focal area of wall thickening and an irregular mass are noted within the esophagus. These findings, particularly in the context of the green 'cancer spots' highlighted, are highly suspicious for a primary esophageal malignancy. While the chest CT is excellent for identifying the location and extent of the lesion, histopathological confirmation via endoscopy with biopsy is the definitive next step for a confirmed diagnosis."
      stepsTitle="Necessary Steps Following an Abnormal CT Scan:"
      stepsText={stepsText}
    />
  );
}
